<div class="vtr-hardware-scan-header-pages">
	<div class="container-fluid">
		<div class="row" [ngSwitch]="getCurrentScanState()">
			<div class="col col-12" *ngSwitchCase="scanStateEnum.StateHome">
				<vtr-hardware-scan-wait-select-header
					[disableButtonScan]="disableButtonScan"
					(startQuickScan)="onQuickScan()"
					(checkAnchor)="onAnchor()">
				</vtr-hardware-scan-wait-select-header>
			</div>
			<div class="col col-12" *ngSwitchCase="scanStateEnum.StateExecuting">
				<vtr-hardware-scan-executing-header
					[subTitle]="getDeviceSubTitle()"
					[percent]="percent"
					(checkCancel)="onCancel()"
					[completed]="completed"
					[disableCancel]="disableCancel">
				</vtr-hardware-scan-executing-header>
			</div>
			<div class="col col-12" *ngSwitchCase="scanStateEnum.StateFinished">
				<vtr-hardware-scan-finished-header
					(scanAgain)="onScanAgain()">
				</vtr-hardware-scan-finished-header>
			</div>
			<div class="col col-12" *ngSwitchDefault>
			</div>
		</div>
	</div>
</div>
